var selectEl = document.querySelector("select[data-variant-input]");
var selectedOption = selectEl.querySelector("option:checked");
var variantId = selectedOption.getAttribute("data-variant-id");

var activeVariant = document.getElementById("active_variant_" + variantId);
activeVariant.style.display = "block";

selectEl.addEventListener('change', function (event) {
  setTimeout(function () {
    var path = window.location.href;
    var variant_id = path.split("=")[1];
    document
      .querySelectorAll(".active_variant")
      .forEach((el) => (el.style.display = "none"));
    document.getElementById("active_variant_" + variant_id).style.display =
      "block";
    document.getElementById("hidden_variant_id").value = variant_id;
  }, 1000);
})

function openModal(e, get_pattern, variant_id) {
  e.nextElementSibling.style.display = "block";
  document.body.style.overflow = "hidden"; 

  var span = document.getElementById("close_" + variant_id);
  span.onclick = function () {
    document.getElementById(
      "wallpaper_calculator_modal_" + variant_id
    ).style.display = "none";
    document.body.style.overflow = "";
  };

  window.onclick = function (event) {
    if (event.target == e.nextElementSibling) {
      document.getElementById(
        "wallpaper_calculator_modal_" + variant_id
      ).style.display = "none";
      document.body.style.overflow = "";
    }
  };
}


function getValue(data_modal_id, pattern) {
  var input_values_array = [];
  var sum_wall_width = 0;
  var pattern1 = "Förskjuten";
  var pattern2 = "Rak";
  var repeats_in_height = 1;
  var repeats_in_width = 1;
  var total_repeats = 1;
  var meter_margin_excl = 1;
  var meter_margin_incl = 1;
  var roll_needed_excl = 1;
  var roll_needed_incl = 1;
  var roll_length =
    parseFloat(
      document.getElementById("hidden_variant_length_" + data_modal_id).value
    ) || 1;

  var el = document
    .getElementById("wallpaper_calculator_modal_" + data_modal_id)
    .getElementsByClassName("custom_text_number");
  for (var i = 0; i < el.length; i++) {
    input_values_array.push(el[i].value ? parseFloat(el[i].value) : 0);
  }

  for (var i = 0; i < input_values_array.length; i++) {
    if (i == 1 || (i > 1 && i < 5)) {
      sum_wall_width += input_values_array[i];
    }

    if (pattern1 == pattern) {
      var x =
        Math.ceil(input_values_array[0] / input_values_array[5]) *
          input_values_array[5] -
        input_values_array[0];
      var y = input_values_array[5] / 2;
      if (x > y) {
        repeats_in_height =
          Math.ceil(input_values_array[0] / input_values_array[5]) - 0.5;
        total_repeats = Math.ceil(repeats_in_height * repeats_in_width);
      } else {
        repeats_in_height =
          Math.ceil(input_values_array[0] / input_values_array[5]) + 0.5;
        total_repeats = Math.floor(repeats_in_height * repeats_in_width);
      }
    }
    if (pattern2 == pattern) {
      repeats_in_height = Math.ceil(
        input_values_array[0] / input_values_array[5]
      );
      total_repeats = repeats_in_height * repeats_in_width;
    }

    repeats_in_width = Math.ceil(sum_wall_width / input_values_array[6]);
    meter_margin_excl = total_repeats * input_values_array[5];
    meter_margin_incl = Math.round(meter_margin_excl * 1.1);
    roll_needed_excl = Math.ceil(meter_margin_excl / roll_length);
    roll_needed_incl = Math.ceil(meter_margin_incl / roll_length);

    document.getElementById("rolls_count_" + data_modal_id).innerHTML =
      roll_needed_incl > 0 ? roll_needed_incl : 0;
  }
}

function validateNumber(e) {
  const pattern = /^[0-9]$/;
  return pattern.test(e.key);
}
